import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { referralPartnerApi } from '@/api/referralPartner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';

export default function PartnerRegister() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    email: '',
    password: '',
    firstName: '',
    lastName: '',
    phone: '',
    partnerType: 'DOCTOR',
    termsAccepted: false,
  });
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.termsAccepted) {
      toast.error('Please accept terms and conditions');
      return;
    }
    setLoading(true);
    try {
      await referralPartnerApi.register({ ...form, termsAccepted: true });
      toast.success('Registration submitted. You will be notified when approved.');
      navigate('/partner/login');
    } catch (err: unknown) {
      const msg = (err as { response?: { data?: { message?: string } } })?.response?.data?.message;
      toast.error(msg || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0a0f1a] px-4 py-12">
      <div className="relative w-full max-w-lg rounded-3xl border border-white/10 bg-slate-900/80 p-5 sm:p-8 shadow-2xl backdrop-blur-xl">
        <h1 className="text-2xl font-bold text-white">Partner registration</h1>
        <p className="mt-1 text-sm text-slate-400">Join our Fast Growing Network</p>
        <form onSubmit={submit} className="mt-6 grid gap-3 sm:grid-cols-2">
          <Input
            placeholder="First name"
            value={form.firstName}
            onChange={(e) => setForm({ ...form, firstName: e.target.value })}
            className="border-white/10 bg-white/5 text-white sm:col-span-1 h-11"
            required
          />
          <Input
            placeholder="Last name"
            value={form.lastName}
            onChange={(e) => setForm({ ...form, lastName: e.target.value })}
            className="border-white/10 bg-white/5 text-white h-11"
            required
          />
          <Input
            type="email"
            placeholder="Email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="border-white/10 bg-white/5 text-white sm:col-span-2 h-11"
            required
          />
          <Input
            placeholder="10-digit mobile"
            value={form.phone}
            onChange={(e) => setForm({ ...form, phone: e.target.value })}
            className="border-white/10 bg-white/5 text-white sm:col-span-2 h-11"
            maxLength={10}
            required
          />
          <Input
            type="password"
            placeholder="Password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            className="border-white/10 bg-white/5 text-white sm:col-span-2 h-11"
            required
          />
          <label className="flex items-start gap-2 text-sm text-slate-300 sm:col-span-2">
            <input
              type="checkbox"
              checked={form.termsAccepted}
              onChange={(e) => setForm({ ...form, termsAccepted: e.target.checked })}
              className="mt-1"
            />
            I accept the terms and confirm I will obtain patient consent before sharing details.
          </label>
          <Button
            type="submit"
            disabled={loading}
            className="sm:col-span-2 bg-gradient-to-r from-cyan-500 to-violet-600 h-11"
          >
            {loading ? 'Submitting…' : 'Submit for approval'}
          </Button>
        </form>
        <p className="mt-4 text-center text-sm text-slate-400">
          <Link to="/partner/login" className="text-cyan-400 hover:underline">
            Back to sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
